import styled from "styled-components";

export const LoaderWrapper = styled.div`
  height: 39px;
  margin-bottom: 18px;
`;
